module.exports = __webpack_public_path__ + "static/media/hello.df35e1f8.jpg";